<template>
    <div class="modal fade" :id="modalid" tabindex="-1" :aria-labelledby="modalid + 'Label'" aria-hidden="true">
        <div class="modal-dialog" :style="getStylesDialog()">
            <div class="modal-content">
                <form @submit.prevent="saveModal()">
                    <div class="modal-header">
                        <h5 v-if="title" class="modal-title" :id="modalid + 'Label'">{{ title ?? "" }}</h5>
                        <button v-if="dismissable" type="button" class="btn-close" style="color: #000;"
                            data-bs-dismiss="modal" aria-label="Close"><font-awesome-icon
                                icon="fa-solid fa-xmark" /></button>
                    </div>
                    <form action="">
                        <div class="modal-body">
                            <slot></slot>
                        </div>
                        <div v-if="this.$slots.footer" class="modal-footer">
                            <slot name="footer"></slot>
                        </div>
                    </form>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalVue",
    props: {
        modalid: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        dismissable: {
            type: Boolean,
            default: false,
        },
        maxwidth: {
            type: String,
            default: "500px",
        }
    },
    methods: {
        getStylesDialog() {
            let styles = {};
            styles['max-width'] = this.maxwidth;
            return styles;
        }
    },
}
</script>